/* eslint-disable react/display-name */
import { FileDoneOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Button, Form, Select, Space, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { AppDispatch } from 'src/index';
import { useForm } from 'antd/es/form/Form';
import styles from 'src/styles/layout.module.css';
import { createOffer, fetchOffers } from 'src/features/companyOffers/companyOffers.state';
import { useOffersValues } from 'src/features/companyOffers/companyOffers.hooks';
import tileStyles from 'src/styles/tile.module.css';

import { useLocationsValues } from 'src/features/locations/locations.hooks';

const { Option } = Select;

const emptyOffer = { langCode: '' };

const CompanyOffersTab: React.FC = () => {
  const createAction = createOffer;
  const entityValues = useOffersValues();

  const { companyId } = useParams() as { companyId: string };
  const dispatch: AppDispatch = useDispatch();
  const [form] = useForm();
  const history = useHistory();

  const locations = useLocationsValues();

  const [createMode, setCreateMode] = useState<boolean>(false);
  const [newEntity, setNewEntity] = useState<{ langCode: string }>(emptyOffer);

  const handleFormSubmit = useCallback(async () => {
    const response = await dispatch(
      createAction({
        companyId,
        data: { ...newEntity, text: 'Введите текст оффера' },
      })
    );

    if (createAction.fulfilled.match(response)) {
      history.push(`/commercial/companies/${companyId}/offers/${response.payload.langCode}`);
    }
  }, [companyId, createAction, dispatch, history, newEntity]);

  const fetchInitialData = useCallback(async () => {
    const response = await dispatch(fetchOffers({ companyId }));
  }, [dispatch, companyId]);

  const handleCreateButtonClick = useCallback(() => {
    setCreateMode(true);
  }, []);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Typography.Title level={4}>Офферы</Typography.Title>
        <Button type='primary' onClick={handleCreateButtonClick}>
          <PlusSquareOutlined />
        </Button>
      </div>
      <div className={styles.content}>
        {createMode && (
          <Form
            form={form}
            validateTrigger='onBlur'
            layout='vertical'
            className={styles.form}
            onFinish={handleFormSubmit}
          >
            <FileDoneOutlined />
            <Form.Item name='langCode' noStyle>
              <Select
                placeholder='Please select a location'
                value={newEntity.langCode}
                onSelect={(e: string) => setNewEntity({ langCode: e })}
                style={{ width: '100%' }}
                defaultOpen
              >
                {locations.map(l => (
                  <Option key={l.code} value={l.code}>
                    {l.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Button htmlType='button' type='default' onClick={() => setCreateMode(false)}>
              Отменить
            </Button>
            <Button htmlType='submit' type='primary' disabled={newEntity.langCode === ''}>
              Создать
            </Button>
          </Form>
        )}
        {entityValues.map(v => (
          <div key={v.langCode} className={tileStyles.listTile}>
            <Link to={`/commercial/companies/${companyId}/offers/${v.langCode}`} className={tileStyles.tileName}>
              <Space>
                <FileDoneOutlined />
                {v.langCode}
              </Space>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyOffersTab;
